import { render, staticRenderFns } from "./accountRecharge.vue?vue&type=template&id=822324bc&scoped=true&"
import script from "./accountRecharge.vue?vue&type=script&lang=js&"
export * from "./accountRecharge.vue?vue&type=script&lang=js&"
import style0 from "./accountRecharge.vue?vue&type=style&index=0&id=822324bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822324bc",
  null
  
)

export default component.exports